import { MovimientoViewModel } from './movimientoViewModel';

export class ListadoMovimientos {
    movimientos: Array<MovimientoViewModel>;
    total: number;
    prevLink: string;
    nextLink: string;
}

export class SaldoViewModel{
    fecha:Date;
    debitos: number;
    creditos: number;
    saldo: number;
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/models/viewmodels/listadoMovimientos.ts